import Hero from "../features/home/components/Hero";
import HeroInfo from "../features/home/components/HeroInfo";
import HoverInfoSection from "../features/home/components/HoverInfoSection";
import Reviews from "../features/home/components/Reviews";
import QASection from "../features/home/components/QASection";
import ParallaxSection from "../features/home/components/ParallaxSection";
import BlogHighlights from "../features/blog/components/BlogHighlights";
import PremiumSection from "../features/home/components/PremiumSection";

function HomePage() {
  return (
    <div className="bg-black">
      <Hero />
      <HeroInfo />
      <HoverInfoSection />
      <Reviews />
      <QASection />
      <ParallaxSection />
      <BlogHighlights />
      <PremiumSection className="bg-customPurple-premium" />
    </div>
  );
}

export default HomePage;
